import React from "react";
import _ from "lodash";
import { FormControl, FormHelperText, InputLabel, Select, MenuItem } from "@material-ui/core";

const SelectDepartment = ({ plans = [], name, value, handleChange, helperText, error, showAll, multiple, disabled = false }) => {
  return (
    <FormControl fullWidth variant="outlined" margin="normal" error={error}>
      <InputLabel>Department</InputLabel>
      <Select
        name={name}
        value={value || ""}
        multiple={multiple}
        onChange={handleChange}
        label="Department"
        error={error}
        disabled={disabled}
      >
        {showAll && <MenuItem value={null}>No Department</MenuItem>}
        {!_.isEmpty(plans) &&
          plans.map(({ id, departmentName }) => (
            <MenuItem key={id} value={id}>
              {departmentName}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText error={error}>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default SelectDepartment;
